import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const SERIES_COLORS = ['#f97316', '#3b82f6', '#10b981'];

const MonthlyBarChart = ({ datasets }) => {
    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        notation: "compact",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
        currency: 'EUR',
        currencyDisplay: 'narrowSymbol'
    });

    const data = {
        labels: MONTH_LABELS,
        datasets: datasets.map((ds, i) => ({
            label: ds.label,
            data: ds.data,
            backgroundColor: SERIES_COLORS[i % SERIES_COLORS.length],
            borderRadius: 0,
            barPercentage: 1.0,
            categoryPercentage: 0.8,
        })),
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            datalabels: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (ctx) => `${ctx.dataset.label}: ${formatter.format(ctx.raw ?? 0)}`,
                },
            },
        },
        scales: {
            x: { grid: { display: false } },
            y: {
                ticks: {
                    callback: (value) => formatter.format(value),
                },
            },
        },
    };

    return (
        <div>
            <Bar data={data} options={options} height={80} />
        </div>
    );
};

export default MonthlyBarChart;
